//--------------- IMPORTAÇÕES ---------------//
import { useContext, useEffect } from "react";
import { IntegracoesContext } from "../context/IntegracoesContext";
import { Cable, Trash2 } from "lucide-react";
import { loadLeadsService } from "../services";



//--------------- EXPORTAÇÃO DO COMPONENTE MAIN ---------------//
export default function ContainerIntegrations() {



    //--------------- CRIAÇÃO DE HOOKS ---------------//
    const { integrations, setIntegrations } = useContext(IntegracoesContext); // Estado que armazena a lista de Integrações
    const { leads, setLeads } = useContext(IntegracoesContext);
    const { integrationSearched, setIntegrationSearched } = useContext(IntegracoesContext);
    const { isOpenModalDeleteIntegration, setIsOpenModalDeleteIntegration } = useContext(IntegracoesContext);
    const { formDataModalDeleteIntegration, setFormDataModalDeleteIntegration } = useContext(IntegracoesContext); // Estado que armazena se Integração deve ser deletada
    const { itemsPerPage, setItemsPerPage } = useContext(IntegracoesContext); // Estado que armazena a quantidade de Itens por Página
    const { currentPage, setCurrentPage } = useContext(IntegracoesContext); // Estado que armazena qual é a Página Atual que está sendo apresentada
    const { isOpenModalIntegration, setIsOpenModalIntegration } = useContext(IntegracoesContext);
    const { formDataModalIntegration, setFormDataModalIntegration } = useContext(IntegracoesContext); // Estado que armazena os dados da Integração para visualização ou edição


    //---------- CRIAÇÃO DE VARIÁVEIS ---------//
    const integrationsFiltred = integrations.filter((integration) => // Variável que armazena as Integrações Filtradas
        integration.nome.toLowerCase().includes(integrationSearched.toLowerCase())
    );
    const paginatedIntegrations = integrationsFiltred.slice( // Variável que armanzena o tatal de Integrações contidads na página
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );



    //---------- USE EFFECT QUE ATUALIZA A CADA MUDANÇA DE PÁGINA, DE ITENS POR PÁGINA E DE FILTRAGEM ----------//
    useEffect(() => {
        handleRefreshLeads();
    }, [currentPage, itemsPerPage]);



    //------------ FUNÇÃO ASSÍNCRONA HANDLE REFRESH LEADS ------------//
    // Responsável por atualizar as leads via API
    // É utilizada a cada mudança nos hooks "currentPage", "itemsPerPage"
    // Armazena as leads no Estado "leads"
    // Armazena o total no Estado "total"
    async function handleRefreshLeads() {
        setLeads(null);
        let filtred_integrations = [];
        let i = itemsPerPage;

        for (i; i > 0; i--) {
            if (integrations[(currentPage * itemsPerPage) - i]) {
                filtred_integrations.push(integrations[(currentPage * itemsPerPage) - i].id);
            }
        }

        const response = await loadLeadsService(filtred_integrations);
            if (response) {
              const todasLeads = [];
              for (let cliente of response.data.clientes) {
                for (let transacao of cliente.transacoes) {
                  todasLeads.push(...transacao.leads);
                }
              }
              setLeads(todasLeads);
            }
    };



    //--------------- FUNÇÃO CONTAR LEADS POR INTEGRAÇÃO ---------------//
    function contarLeadsPorIntegracao(integrationId) {
        if (!Array.isArray(leads) || !integrationId) return 0;

        return leads.filter(
            lead => lead.id_integracao === integrationId
        ).length;
    }



    //--------------- FUNÇÃO CONTAR VENDAS POR INTEGRAÇÃO ---------------//
    function contarVendasPorIntegracao(integrationId, integrationPlataform) {
        if (!Array.isArray(leads) || !integrationId) return 0;
        let tipo_evento;

        if (integrationPlataform === "hotmart") {
            tipo_evento = "PURCHASE_APPROVED"
        } else
            if (integrationPlataform === "kiwify") {
                tipo_evento = "order_approved"
            } else
                if (integrationPlataform === "lastlink") {
                    tipo_evento = "COMPRA APROVADA"
                }

        return leads.filter(
            lead => lead.id_integracao === integrationId && (lead.tipo_evento === tipo_evento)
        ).length;
    }






    //--------------- RETORNO DO COMPONENTE MAIN ---------------//
    return (
        <>

            {/* DIV QUE CONTÊM AS TAGS */}
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 mb-6">

                {/* CONSTRUÇÃO DAS TAGS NA PÁGINA */}
                {paginatedIntegrations.map((integration) => (
                    <div key={integration.id} className="bg-surface-2 border border-white/[0.08] rounded-xl p-4 flex items-center justify-between hover:cursor-pointer">

                        <div onClick={() => {
                            setFormDataModalIntegration({ nome: integration.nome, plataforma: integration.plataforma, status: integration.status, id: integration.id, endpoint_path: integration.endpoint_path });
                            setIsOpenModalIntegration(true);
                        }} className="flex items-center gap-3 flex-grow min-w-0">

                            <Cable className={`flex-shrink-0 w-6 h-6 ${integration.status ? "text-brand-400" : "text-ink-3"}`} />

                            <div className="min-w-0">
                                <div className="font-sm text-white truncate"><b>{integration.nome}</b> ({integration.plataforma})</div>
                                <div className="text-sm text-ink-3 truncate">Leads:  {!leads ? <i class="fas fa-circle-notch fa-spin opacity-70"></i> : contarLeadsPorIntegracao(integration.id)}</div>
                                <div className="text-sm text-ink-3 truncate">Vendas: {!leads ? <i class="fas fa-circle-notch fa-spin opacity-70"></i> : contarVendasPorIntegracao(integration.id, integration.plataforma)}</div>
                            </div>

                        </div>

                        <button className="flex-shrink-0" onClick={() => {
                            setIsOpenModalDeleteIntegration(true);
                            setFormDataModalDeleteIntegration({ integration: integration })
                        }}>
                            <Trash2 className="w-5 h-5 text-ink-3 hover:text-red-500" />
                        </button>
                    </div>
                ))}

                {paginatedIntegrations.length === 0 && (
                    <div className="col-span-full text-center text-ink-3">
                        Nenhuma integração encontrada.
                    </div>
                )}

            </div >

        </>
    )
}